import type { SemanticColourTheme } from './types';

/**
 * The decorative surface palette, as an ordered sequence.
 *
 * `semantic.colour.decorative` is keyed by hue, but consumers need a stable
 * indexable list: avatars pick a colour with `getKeyFromText`, which does
 * `keys[hash(name) % keys.length]`, and `Tag` indexes it directly by its
 * numeric `variant` prop.
 *
 * That makes **both the order and the length load-bearing**. Reordering this
 * tuple silently reassigns every existing avatar's colour, and adding or
 * removing a hue reshuffles all of them. The order below is the order the legacy
 * `palette.decorative` array used, so nothing changes. RWR-18028.
 */
const DECORATIVE_ORDER = [
  'yellow',
  'green',
  'teal',
  'blue',
  'purple',
  'pink',
  'coral',
] as const;

export const getDecorativeSurfaces = (colour: SemanticColourTheme) =>
  DECORATIVE_ORDER.map((hue) => colour.decorative[hue].surface);
